export default __webpack_public_path__ + "900c975c8a8a978ce33fc099f456dc01.svg";